import { ToolTip } from "@/components/common/ToolTip/ToolTip";
import { BottomModal } from "components/common/BottomModal/BottomModal";
import { BottomSectionContainer } from "components/common/BottomModal/BottomSectionContainer";
import { SKIP_TOUCH_ID_BOTTOM_MODAL } from "components/common/BottomModal/useBottomModal";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { SettingsIcon } from "components/common/Icons/SettingsIcon";
import { Translate } from "components/common/Translate/Translate";
import { BulkResizeSettings } from "../../EditSettings/ResizeSettings/BulkResizeSettings";
import { ExportSettings } from "../../ExportSettings/ExportSettings";
import { useExportSettings } from "../../ExportSettings/useExportSettings";
import { useResizeSettingsOption } from "./useResizeSettingsOption";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { Loader } from "components/common/Icons/Loader/Loader";
import { RightIcon } from "components/common/Icons/RightIcon";

export const ResizeSettingsOption = ({ onOpen }: { onOpen?: () => void }) => {
    const { isOpen, open, close } = useResizeSettingsOption();
    const { validDimensions, unImportedImages, isProceedButtonActive, handleProceed, isProcessing } =
        useExportSettings();

    return (
        <div
            className="flex items-center justify-center w-full gap-2 py-4 border-r sm:gap-4 border-r-irBlue-400"
            onClick={() => {
                open();
                onOpen?.();
            }}
        >
            <SettingsIcon className="stroke-white" />
            <div className="text-sm font-semibold text-white capitalize sm:text-xl whitespace-nowrap">
                <Translate keyName="resize-settings" />
            </div>

            <BottomModal
                isOpen={isOpen}
                onClose={close}
                titleBar={
                    <div className="flex items-center justify-between w-full px-4 pt-2 text-black dark:text-white">
                        <div className="text-xl font-semibold capitalize whitespace-nowrap">
                            <Translate keyName="resize-settings" />
                        </div>
                        <div onClick={close} className="">
                            <div
                                className="flex items-center justify-center w-6 h-6 rounded-full bg-irGray-300 dark:bg-darkSurface-200"
                                id={SKIP_TOUCH_ID_BOTTOM_MODAL}
                            >
                                <CloseIcon />
                            </div>
                        </div>
                    </div>
                }
                initialHeight="60vh"
                bottomSection={
                    <BottomSectionContainer>
                        <ToolTip
                            text={
                                !validDimensions
                                    ? translateFunc("dimensions-error")
                                    : unImportedImages.length > 0
                                      ? translateFunc("uploading-wait-label")
                                      : translateFunc("proceed-to-download-page")
                            }
                            containerClassNames="lg:hidden block w-full"
                        >
                            <div
                                className={`cursor-pointer flex lg:hidden items-center px-8 py-4 ${
                                    isProceedButtonActive
                                        ? "bg-irBlue-200 hover:bg-irBlue-400"
                                        : "bg-irGray-400 dark:bg-darkSurface-600"
                                } gap-4 rounded-lg justify-center my-4`}
                                onClick={handleProceed}
                                data-testid={`export-${isProceedButtonActive ? "active" : "inactive"}-button`}
                            >
                                <div className="font-semibold text-white capitalize select-none lg:font-normal">
                                    {capitalize(translateFunc("resize-images"))}
                                </div>
                                {isProcessing ? (
                                    <Loader className="stroke-white" width={18} height={18} />
                                ) : (
                                    <RightIcon className="fill-white" />
                                )}
                            </div>
                        </ToolTip>
                    </BottomSectionContainer>
                }
            >
                <>
                    <BulkResizeSettings />
                </>
            </BottomModal>
        </div>
    );
};
